import { render } from "./SectionLoading.vue?vue&type=template&id=aae6b91e"
import script from "./SectionLoading.vue?vue&type=script&lang=js"
export * from "./SectionLoading.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__